(function () {
  var MONTH_WORDS = {
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6,
    seven: 7,
    eight: 8,
    nine: 9,
    ten: 10,
    a: 1
  };

  function selectedCard() {
    return document.querySelector('.vbc input[type="radio"]:checked');
  }

  function toDays(value, pieces) {
    if (pieces && Number(pieces) > 0) return String(Number(pieces));
    if (value == null || value === '') return '';

    var text = String(value).toLowerCase();
    var dayMatch = text.match(/(\d+)\s*days?/);
    if (dayMatch) return dayMatch[1];

    var monthMatch = text.match(/(\d+|one|two|three|four|five|six|seven|eight|nine|ten|a)\s*-?\s*months?/);
    if (monthMatch) {
      var months = MONTH_WORDS[monthMatch[1]] || parseInt(monthMatch[1], 10);
      if (months) return String(months * 30);
    }

    if (/monthly|every\s+month|one\s+month/.test(text)) return '30';

    if (/month/.test(text)) {
      var monthNumber = parseInt(text.replace(/[^\d]/g, ''), 10);
      return String((monthNumber || 1) * 30);
    }

    if (/week/.test(text)) {
      var weeks = parseInt(text.replace(/[^\d]/g, ''), 10) || 1;
      return String(weeks * 7);
    }

    return '';
  }

  function planData(root) {
    var node = root.querySelector('.freq__plan-data');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]') || [];
    } catch (error) {
      return [];
    }
  }

  function daysFor(root, radio) {
    var cards = document.querySelectorAll('.vbc-tier input[type="radio"][name^="vbc-"]');
    var index = radio ? Array.prototype.indexOf.call(cards, radio) : 0;
    if (index < 0) index = 0;
    var fromSetting = root.getAttribute('data-days-' + (index + 1));
    if (fromSetting && Number(fromSetting) > 0) return String(Number(fromSetting));

    if (radio) {
      var fromCard = toDays(
        [radio.getAttribute('data-interval-raw'), radio.value, radio.getAttribute('data-sub-note')].filter(Boolean).join(' ')
      );
      if (fromCard) return fromCard;
    }

    return '30';
  }

  function planIdFor(root, radio, days) {
    var variantId = radio && radio.getAttribute('data-variant-id');
    var rows = planData(root);
    var match = rows.find(function (row) {
      return String(row.days) === String(days) && (!variantId || String(row.variantId) === String(variantId));
    });
    if (match) return String(match.planId);

    var sameVariant = rows.find(function (row) {
      return variantId && String(row.variantId) === String(variantId);
    });
    if (sameVariant) return String(sameVariant.planId);

    return radio && radio.getAttribute('data-plan');
  }

  function applyCardPrices(subscribe) {
    document.querySelectorAll('.vbc-tier').forEach(function (tier) {
      var radio = tier.querySelector('input[type="radio"]');
      if (!radio) return;
      var now = tier.querySelector('.vbc-now');
      var was = tier.querySelector('.vbc-was');
      var sub = tier.querySelector('.vbc-sub');
      var save = tier.querySelector('.vbc-save[data-dynamic="true"]');

      var price = subscribe ? radio.getAttribute('data-sub-price') : radio.getAttribute('data-ot-price');
      var compare = subscribe ? radio.getAttribute('data-sub-was') : radio.getAttribute('data-ot-was');
      var day = subscribe ? radio.getAttribute('data-sub-day') : radio.getAttribute('data-ot-day');
      var savePct = subscribe ? radio.getAttribute('data-sub-save') : radio.getAttribute('data-ot-save');
      var supply = radio.getAttribute('data-supply');

      if (now && price) now.textContent = price;
      if (was) {
        if (compare) {
          was.textContent = compare;
          was.hidden = false;
        } else {
          was.textContent = '';
          was.hidden = true;
        }
      }
      if (sub && supply && day) {
        sub.innerHTML = supply + '&nbsp;•&nbsp;' + day + ' ' + (sub.getAttribute('data-per-label') || 'per day');
      }
      if (save) {
        if (savePct && Number(savePct) > 0) {
          save.textContent = 'SAVE ' + savePct + '%';
          save.removeAttribute('hidden');
          save.hidden = false;
        } else {
          save.textContent = '';
          save.setAttribute('hidden', '');
          save.hidden = true;
        }
      }
    });
  }

  function updateNote(root, radio) {
    var text = root.querySelector('.freq__text');
    if (!text) return;
    var template = text.getAttribute('data-template') || text.textContent || 'Delivered every [days] days. Skip, pause, or cancel anytime online.';
    var days = daysFor(root, radio);
    var rest = template
      .replace(/Delivered every\s*\[days\]\s*days\.?\s*/i, '')
      .replace(/^Delivered every[^.]*\.?\s*/i, '')
      .replace(/^Every[^.]*\.?\s*/i, '');

    text.textContent = rest ? 'Delivered every ' + days + ' days. ' + rest : 'Delivered every ' + days + ' days.';
  }

  function atcButtons(root) {
    var formId = root.getAttribute('data-product-form');
    var form = formId ? document.getElementById(formId) : document.querySelector('form.product-form, product-form form');
    if (!form) return [];
    return Array.prototype.slice.call(form.querySelectorAll('[name="add"], .product-form__submit'));
  }

  function updateAtcLabel(root, checked) {
    atcButtons(root).forEach(function (button) {
      if (!button || button.getAttribute('data-unavailable') === 'true') return;
      var label = button.querySelector('.main-atc__label__text');
      if (!label) return;

      var full = button.getAttribute('data-custom-label') || '';
      var base = button.getAttribute('data-atc-base') || full.replace(/\s*[&+]?\s*SAVE\s+\d+%\s*/i, '').trim();
      if (!base) base = 'ADD TO CART';
      if (!full) full = base;

      if (!/\bSAVE\s+\d+%/i.test(full) && checked) {
        var savePct = root.getAttribute('data-save-pct') || '20';
        full = base + ' & SAVE ' + savePct + '%';
      }

      label.textContent = checked ? full : base;
    });
  }

  function sync(root) {
    var input = root.querySelector('.freq__input');
    var planInput = root.querySelector('.freq__plan');
    var checked = !!(input && input.checked);
    root.classList.toggle('on', checked);

    var radio = selectedCard();
    var days = daysFor(root, radio);
    var planId = planIdFor(root, radio, days);
    if (planInput) planInput.value = checked && planId ? planId : '';

    applyCardPrices(checked);
    updateNote(root, radio);
    updateAtcLabel(root, checked);
  }

  function onChange(event) {
    var input = event.target.closest && event.target.closest('.freq__input');
    if (input) {
      sync(input.closest('.freq'));
      return;
    }

    var radio = event.target.closest && event.target.closest('.vbc input[type="radio"]');
    if (radio) {
      document.querySelectorAll('.freq').forEach(sync);
    }
  }

  function hideAppSubscriptionWidgets() {
    if (!document.body.classList.contains('template-primal-cat-temp') && !document.querySelector('.freq, .vbc')) {
      return;
    }

    document.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.closest('.freq, .vbc, .product__info-container')) return;
      var copy = ((input.closest('label') && input.closest('label').textContent) || input.getAttribute('aria-label') || input.value || '').toLowerCase();
      if (!/one[- ]time purchase|subscribe and save|deliver every/.test(copy)) return;
      var wrap =
        input.closest('.shopify-block, .shopify-app-block, shopify-subscriptions, kaching-subscriptions') ||
        input.closest('[class*="subscription"]') ||
        input.closest('form') ||
        input.parentElement;
      if (!wrap || wrap.closest('.freq, .vbc, header, .header, nav')) return;
      wrap.style.setProperty('display', 'none', 'important');
      if (wrap.parentElement && wrap.parentElement !== document.body && wrap.parentElement.children.length === 1) {
        wrap.parentElement.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function init() {
    hideAppSubscriptionWidgets();
    document.querySelectorAll('.freq').forEach(function (root) {
      var text = root.querySelector('.freq__text');
      if (text && !text.getAttribute('data-template')) {
        text.setAttribute('data-template', text.textContent);
      }
      sync(root);
    });
  }

  document.addEventListener('change', onChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', hideAppSubscriptionWidgets);
})();
